var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignLeftIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77951 1.25H0.220486C0.098715 1.25 0 1.34871 0 1.47049V1.96701C0 2.08879 0.098715 2.1875 0.220486 2.1875H9.77951C9.90129 2.1875 10 2.08879 10 1.96701V1.47049C10 1.34871 9.90129 1.25 9.77951 1.25Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77951 7.8125H0.220486C0.098715 7.8125 0 7.91122 0 8.03299V8.52951C0 8.65128 0.098715 8.75 0.220486 8.75H9.77951C9.90129 8.75 10 8.65128 10 8.52951V8.03299C10 7.91122 9.90129 7.8125 9.77951 7.8125Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69514 2.8125H0.929861C0.761491 2.8125 0.625 2.94899 0.625 3.11736V6.88264C0.625 7.05101 0.761491 7.1875 0.929861 7.1875H4.69514C4.86351 7.1875 5 7.05101 5 6.88264V3.11736C5 2.94899 4.86351 2.8125 4.69514 2.8125Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeftIcon);
export default __webpack_public_path__ + "static/media/AlignLeftIcon.f04f2b8964040e420fe87ed8a3c127e3.svg";
export { ForwardRef as ReactComponent };